import { TFunction } from 'i18next';

import { EventTypeStrategy, EventTypeCellParts } from "./EventTypeStrategy";
import { getTranslatedEventTypeName } from "../../utils/eventTypeUtils";

import { paymentTypeMap } from "@/types/client/ClientType";
import { TransactionType } from "@/types/transaction/TransactionType";

export class ClientBudgetPaymentTypeUpdatedEventStrategy implements EventTypeStrategy {
  renderCell(row: TransactionType, t: TFunction): JSX.Element {
    return <>{t(`eventTypes.${row.eventType}`)}{row.eventData.newPaymentType === undefined ? "" : <> {t("to")} <b>{paymentTypeMap[row.eventData.newPaymentType]}</b></>}</>;
  }

  getTypeAndDescription(row: TransactionType, t: TFunction): EventTypeCellParts {
    return {
      type: <>{getTranslatedEventTypeName(row.eventType, t)}</>,
      description: <>{row.eventData.newPaymentType === undefined ? "" : <> {t("to")} <b>{paymentTypeMap[row.eventData.newPaymentType]}</b></>}</>
    };
  }
}
